export default __webpack_public_path__ + "static/media/x-bluebg.9553c0f8.png";